import React, { useEffect, useState } from "react";
import Section1 from "../../components/Section1";
import LayoutsList from "../../components/LayoutsList";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faXmark } from "@fortawesome/free-solid-svg-icons";
import { apiUrl, assetsUrl } from "../../config/Config";
import axios from "axios";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";

import googleicon from "../../assets/images/google_icon.png";

import Spinner from "react-activity/dist/Spinner";
import "react-activity/dist/Spinner.css";

import { GoogleLogin, useGoogleLogin } from '@react-oauth/google';
import { jwtDecode } from "jwt-decode";
import { useDispatch, useSelector } from 'react-redux';

const RegisterPage = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const [fullname, setfullname] = useState("");
  const [emailaddress, setemailaddress] = useState("");
  const [phonenumber, setphonenumber] = useState("");
  const [password, setpassword] = useState("");
  const [repassword, setrepassword] = useState("");

  const [fullnameerrormessage, setfullnameerrormessage] = useState("");
  const [emailaddresserrormessage, setemailaddresserrormessage] = useState("");
  const [phonenumbererrormessage, setphonenumbererrormessage] = useState("");
  const [passworderrormessage, setpassworderrormessage] = useState("");
  const [repassworderrormessage, setrepassworderrormessage] = useState("");
  const [mismatchpassworderrormessage, setmismatchpassworderrormessage] =
    useState("");

  const [showloading, setshowloading] = useState(false);

  const isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const isValidPhoneNumber = (phone) => {
    const regex = /^\+[1-9]\d{7,14}$/;
    return regex.test(phone);
  };

  const handlesignupwithgoogle = async(token) => {
    // setshowloading(true);
    var data = {
      token: token,
    };

    try {
      const res = await axios.post(apiUrl + "userregisterviagoogle", data, {
        headers: { "Content-Type": "application/json" },
      });
      if (res.data.status === "success") {
        setshowloading(false);
        dispatch({ type: "inkcustomerdata", payload: res.data.data })
        // navigate('/user-profile');
        const frompagetologin = localStorage.getItem("frompagetologin");
            if(frompagetologin) {
              localStorage.removeItem("frompagetologin");
              window.location.href = frompagetologin;
            } else {
              navigate('/user-profile');
            }
      } else {
        alert(res.data.message || "Registration Failed.");
        // setshowloading(false);
      }
    } catch (err) {
      console.error("API Error:", err);
      alert("Network or Server Error!");
      // setshowloading(false);
    }
    // setshowloading(false);
  }

  const handleSuccess = (credentialResponse) => {
    // const decoded = jwtDecode(credentialResponse.credential);
    // console.log("User Info:", decoded);
    const token = credentialResponse.credential;
    console.log("Token:", token);
    handlesignupwithgoogle(token);

    // Send this token to your backend (Laravel API)
  };

  const googlelogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      console.log('tokenResponse >>', tokenResponse);
  
      const accessToken = tokenResponse.access_token;
  
      handlesignupwithgoogle(accessToken);
    },
  });


  const handlesignupfunc = async () => {
    var isfullnameerror = false;
    var isemailaddresserror = false;
    var isphonenumbererror = false;
    var ispassworderror = false;
    var isrepassworderror = false;
    var ismismatchpassworderror = false;

    if (fullname) {
      isfullnameerror = false;
      setfullnameerrormessage("");
    } else {
      isfullnameerror = true;
      setfullnameerrormessage("Full Name cannot be empty.");
    }

    if (emailaddress && isValidEmail(emailaddress)) {
      isemailaddresserror = false;
      setemailaddresserrormessage("");
    } else {
      isemailaddresserror = true;
      if (emailaddress) {
        setemailaddresserrormessage("Invalid Email Address.");
      } else {
        setemailaddresserrormessage("Email Address cannot be empty.");
      }
    }

    if (phonenumber && isValidPhoneNumber(phonenumber)) {
      isphonenumbererror = false;
      setphonenumbererrormessage("");
    } else {
      isphonenumbererror = true;
      setphonenumbererrormessage("Invalid Mobile Number.");
    }

    if (password) {
      ispassworderror = false;
      setpassworderrormessage("");
    } else {
      ispassworderror = true;
      setpassworderrormessage("Enter Password.");
    }

    if (repassword) {
      isrepassworderror = false;
      setrepassworderrormessage("");
    } else {
      isrepassworderror = true;
      setrepassworderrormessage("Enter Re-Password.");
    }

    if (
      !isfullnameerror &&
      !isemailaddresserror &&
      !isphonenumbererror &&
      !ispassworderror &&
      !isrepassworderror &&
      !ismismatchpassworderror
    ) {
      if (password == repassword) {
        console.log("validation passed!!");
        ismismatchpassworderror = false;
        setmismatchpassworderrormessage("");
      } else {
        ismismatchpassworderror = true;
        setmismatchpassworderrormessage(
          "Password & Re-password does not match!!"
        );
        return;
      }
    } else {
      console.log("validation failed!!");
      // alert("validation failed!!");
      return;
    }
    setshowloading(true);
    var data = {
      fullname: fullname,
      emailaddress: emailaddress,
      mobilenumber: phonenumber,
      password: password,
      via: "form",
    };

    try {
      const res = await axios.post(apiUrl + "userregister", data, {
        headers: { "Content-Type": "application/json" },
      });
      if (res.data.status === "success") {
        setshowloading(false);
        navigate("/verify-email-address", {
          state: {
            semail: emailaddress,
            screen: "signup",
          },
        });
      } else {
        alert(res.data.message || "Registration Failed.");
        setshowloading(false);
      }
    } catch (err) {
      console.error("API Error:", err);
      alert("Network or Server Error!");
      setshowloading(false);
    }
    setshowloading(false);
  };

  return (
    <div className="homepage-layout">
      <section>
        <div className=" findlayout_section1main regsiterpagemaindiv">
          <div className="container">
            <div className="registermaindiv">
              <p className="section1title">
                <span className="gradient-head">Create Your Account</span>
              </p>
              <div className="register-inputdiv">
                <label>Full Name *</label>
                <input
                  type="text"
                  value={fullname}
                  onChange={(t) => {
                    setfullname(t.target.value);
                  }}
                  className="register-textinput form-control"
                  placeholder="Enter your full name"
                />
                {fullnameerrormessage ? (
                  <p className="register-error-message">
                    {fullnameerrormessage}
                  </p>
                ) : null}
              </div>
              <div className="register-inputdiv">
                <label>Email Address *</label>
                <input
                  type="text"
                  value={emailaddress}
                  onChange={(t) => {
                    setemailaddress(t.target.value);
                  }}
                  className="register-textinput form-control"
                  placeholder="Enter your email address"
                />
                {emailaddresserrormessage ? (
                  <p className="register-error-message">
                    {emailaddresserrormessage}
                  </p>
                ) : null}
              </div>
              <div className="register-inputdiv">
                <label>Mobile Number *</label>
                <PhoneInput
                  defaultCountry="in"
                  name="mobile"
                  value={phonenumber}
                  onChange={(e) => {
                    // setFormData({ ...formData, mobile: e });
                    setphonenumber(e);
                  }}
                  style={{ marginBottom: 15 }}
                />
                {phonenumbererrormessage ? (
                  <p className="register-error-message phonenumbererrormessage">
                    {phonenumbererrormessage}
                  </p>
                ) : null}
              </div>
              <div className="row register-inputdivrow">
                <div className="col-md-6">
                  <div className="register-inputdiv">
                    <label>Password *</label>
                    <input
                      type="password"
                      value={password}
                      onChange={(t) => {
                        setpassword(t.target.value);
                      }}
                      className="register-textinput form-control"
                      placeholder="Enter your password"
                    />
                    {passworderrormessage ? (
                      <p className="register-error-message">
                        {passworderrormessage}
                      </p>
                    ) : null}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="register-inputdiv">
                    <label>Re-type Password *</label>
                    <input
                      type="password"
                      value={repassword}
                      onChange={(t) => {
                        setrepassword(t.target.value);
                      }}
                      className="register-textinput form-control"
                      placeholder="Re-enter your password"
                    />
                    {repassworderrormessage ? (
                      <p className="register-error-message">
                        {repassworderrormessage}
                      </p>
                    ) : null}
                  </div>
                </div>
              </div>
              {mismatchpassworderrormessage ? (
                <p className="register-error-message">
                  {mismatchpassworderrormessage}
                </p>
              ) : null}
              <div
                className="registersubmitbtn"
                onClick={() => {
                  if(showloading) {

                  } else {
                    handlesignupfunc();
                  }
                  
                }}
              >
                { showloading ?
                  <div className="spinnermaindiv">
                  <Spinner
                    color="#fff"
                    size={16}
                    className="spinnerCenter"
                  />
                </div> :
                <p>Sign Up</p>
                }
                
              </div>
              <div className="orborderdiv">
                <div className="orderline1"></div>
                <div className="ortextdiv">
                  <p>OR</p>
                </div>
                <div className="orderline1"></div>
              </div>
              <div className="continuewithgoogleicon">
                {/* <div className="continuewithgoogleiconrow" onClick={() => {
                  googlelogin()
                }}>
                  <img src={googleicon} className="googleicon" />
                  <p>Continue With Google</p>
                </div> */}
                <GoogleLogin
                  onSuccess={handleSuccess}
                  onError={() => console.log("Login Failed")}
                />
              </div>
              <div className="alreadyhaveaccountdiv">
                <p className="alreadyhaveaccounttext">
                  Already have an account ?
                </p>
                <p
                  className="signintext"
                  onClick={() => {
                    navigate("/login");
                  }}
                >
                  Sign In
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RegisterPage;
